import React from "react";
import "./ClientFormHeader.css";

const ClientFormHeader = () => {
  return (
    <section className="ClientFormHeader-container">
      <div className="ClientFormHeader-overlay">
        <div className="container" style={{ textAlign: "center" }}>
          <h1 className="ClientFormHeader-title">Need Employees ?</h1>
          <div className="ClientFormHeader-breadcrumb">
            <button className="btn btn-primary">Home - Client Form</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientFormHeader;
